export default __webpack_public_path__ + "static/media/Elijah cv new.d54ca96d.pdf";